import { isJsonString, parsePlainTextToJSON } from '@mvrb-frontend/shared-ui/lib/utils/utils';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { useState } from 'react';
import CommentSetModel from '../components/comments/CommentSetModel';

import { AxiosPrivate } from '../utils/axios';

export const useGetCommentSet = () => {
  const [isFetching, setFetching] = useState(false);

  const getOneCommentSetByParams = async (
    reviewId,
    organizationId,
    authorId,
    withComments,
    published,
  ): Promise<CommentSetModel | null> => {
    try {
      const params = {
        organizationId,
        authorId,
        withComments,
        published,
      };

      const url = `/comment-set/oneby/${reviewId}`;

      setFetching(true);
      const { data } = await AxiosPrivate.get(url, { params });
      if (data.comments.length > 0) {
        data.comments.forEach(c => (c.customTopic = parsePlainTextToJSON(c.customTopic)));
      }

      return data ? new CommentSetModel(data) : null;
    } catch (e) {
      return null;
    } finally {
      setFetching(false);
    }
  };

  const getCommentSetsByParams = async (
    reviewId,
    organizationId,
    authorId,
    withComments,
    published,
    skip?,
    take?,
  ): Promise<CommentSetModel[] | null> => {
    try {
      const params = {
        organizationId,
        authorId,
        withComments,
        published,
      };

      //Add params when pagination is requested
      if (skip || take) {
        Object.assign(params, { skip, take });
      }

      const url = `/comment-set/filter/${reviewId}`;

      setFetching(true);
      const { data } = await AxiosPrivate.get(url, { params });

      data.map(commentSet => {
        if (commentSet.comments.length > 0) {
          return commentSet.comments.map(comment => {
            comment.customTopic = parsePlainTextToJSON(comment.customTopic);
            return comment;
          });
        }
      });

      return data.map(cs => new CommentSetModel(cs));
    } catch (e) {
      return null;
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    getOneCommentSetByParams,
    getCommentSetsByParams,
  };
};
